import React from "react";
import { Card, CardContent, Typography, Grid, Button } from "@mui/material";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Line, LineChart, Legend } from "recharts";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CoffeeIcon from "@mui/icons-material/Coffee";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
const timeUtilisation = [
  { name: "Working", value: 70 },
  { name: "Idle", value: 30 },
];
const COLORS = ["#3f51b5", "#e0e0e0"];
const attendanceRecords = [
    { id: 1, date: "2024-03-10", punchingTime: "09:00 AM", punchoutTime: "06:00 PM", breakTime: "01:00 Hr", halfDay: false, fullDay: true, overTime: "01:30 Hr", totalProduction: "07:30 Hr" },
    { id: 2, date: "2024-03-11", punchingTime: "09:30 AM", punchoutTime: "01:00 PM", breakTime: "00:30 Hr", halfDay: true, fullDay: false, overTime: "00:00 Hr", totalProduction: "03:00 Hr" },
  ];
const yearlyStatus = [
  { year: "2001", workingHours: 400, progress: 20 },
  { year: "2002", workingHours: 500, progress: 30 },
  { year: "2003", workingHours: 420, progress: 25 },
  { year: "2004", workingHours: 650, progress: 35 },
  { year: "2005", workingHours: 200, progress: 15 },
  { year: "2006", workingHours: 450, progress: 28 },
  { year: "2007", workingHours: 250, progress: 18 },
  { year: "2008", workingHours: 480, progress: 30 },
  { year: "2009", workingHours: 700, progress: 40 },
  { year: "2010", workingHours: 460, progress: 25 },
  { year: "2011", workingHours: 350, progress: 18 },
  { year: "2012", workingHours: 220, progress: 12 },
];

const recentActivities = [
  { id: 1, type: "Punch In", time: "10:00 AM" },
  { id: 2, type: "Punch Out", time: "11:30 AM" },
];

export default function AttendanceEmp() {
  return (
    <Grid container spacing={2} padding={2}>
      <Grid item xs={12}>
        <Typography variant="h4" sx={{ fontWeight: "bold", textAlign:"left", color: "black",  marginBottom: 2 }}>
          Attendance Employee
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
      <Card sx={{ textAlign: "left", padding: 2 }}>
      {/* <Card sx={{ textAlign: "left", padding: 2 }}> */}
      <CardContent>
        <Typography variant="h6" sx={{ marginBottom: 2,fontWeight:"bold" }}>Today Time Utilisation</Typography>

        {/* Working + Punch Out Button */}
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>Working 70%</Typography>
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary">Punch Out</Button>
          </Grid>
        </Grid>

          <PieChart width={200} height={200} style={{ margin: "auto" }}>
          <Pie data={timeUtilisation} dataKey="value" cx="50%" cy="50%" innerRadius={50} outerRadius={80}>
            {timeUtilisation.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>

        <Grid container spacing={2} sx={{ marginTop: 1 }}>
          <Grid item xs={6} display="flex" alignItems="center">
            <CoffeeIcon sx={{ marginRight: 1,color:"cadetblue" }} />
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>Break: 1:10 Hr</Typography>
          </Grid>
          <Grid item xs={6} display="flex" alignItems="center" justifyContent="flex-end">
            <AccessTimeIcon sx={{ marginRight: 1,color:"green" }} />
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>Overtime: 02:10 Hr</Typography>
          </Grid>
        </Grid>

      </CardContent>
    {/* </Card> */}
</Card>

      </Grid>

      <Grid item xs={12} md={8}>
        <Card sx={{ padding: 2 }}>
          <CardContent>
            <Typography variant="h6" sx={{ marginBottom: 2,textAlign:"left", fontWeight:"bold"}}>Employees Yearly Status</Typography>
            <BarChart width={800} height={300} data={yearlyStatus}>
              <XAxis dataKey="year" />
              <YAxis yAxisId="left" orientation="left" label={{ value: "Working Hours", angle: -90, position: "insideLeft" }} />
              <YAxis yAxisId="right" orientation="right" label={{ value: "Progress", angle: -90, position: "insideRight" }} />
              <Tooltip />
              <Legend />
              <Bar yAxisId="left" dataKey="workingHours" fill="#3f51b5" />
            </BarChart>
           
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card sx={{ padding: 2 }}>
          <CardContent>
            <Typography variant="h6" sx={{ marginBottom: 2,textAlign:"left", fontWeight:"bold"}}>Attendance Records</Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Punching Time</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Punchout Time</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Break Time</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Half Day</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Full Day</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Overtime</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Total Production</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {attendanceRecords.map((record) => (
                    <TableRow key={record.id}>
                      <TableCell>{record.id}</TableCell>
                      <TableCell>{record.date}</TableCell>
                      <TableCell>{record.punchingTime}</TableCell>
                      <TableCell>{record.punchoutTime}</TableCell>
                      <TableCell>{record.breakTime}</TableCell>
                      <TableCell>{record.halfDay ? <ClearIcon sx={{ color: "red" }} /> : "-"}</TableCell>
                      <TableCell>{record.fullDay ? <CheckIcon sx={{ color: "green" }} /> : "-"}</TableCell>
                      <TableCell>{record.overTime}</TableCell>
                      <TableCell>{record.totalProduction}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
